import { MIME_TYPES } from 'utils/asset';

export const DROP_ZONE_PLACEHOLDER = 'Drag and drop Logo Image here.';

export const ALLOWED_MIME_TYPES = [MIME_TYPES.PNG, MIME_TYPES.JPEG, MIME_TYPES.SVG];

export const REPLACE_REMOVE_LOGO_PLACEHOLDER = 'Replace or Remove Logo';
export const UPLOAD_LOGO_PLACEHOLDER = 'Upload Logo';

export const NEW_LOGO_TITLE = 'Upload Logo';
export const SHOW_LOGO_TITTLE = 'Uploaded Logo';
